// extracted by mini-css-extract-plugin
export var contentBody = "_bl-9";
export var headerImage = "_bl-2";
export var imageButton = "_bl-7";
export var imageButtonIcon = "_bl-8";
export var imageHeader = "_bl-4";
export var imageHeaderText = "_bl-5";
export var imageOverlay = "_bl-3";
export var imageTitle = "_bl-6";
export var imageWrapper = "_bl-1";
export var taskList = "_bl-a";
export var widget = "_bl-0";